import { z } from 'zod'
import { route } from '../route-def'

export const HealthResponseSchema = z.object({ status: z.enum(['ok', 'down']), version: z.string() })
export type HealthResponse = z.infer<typeof HealthResponseSchema>

export const healthRoutes = {
  health: route({ method: 'GET', path: '/api/health', auth: 'public', response: HealthResponseSchema }),
}
